module.exports = __webpack_public_path__ + "img/board_edit-en.7f51a543.png";